export default [
    {
        path: 'atividade-coletiva',
        component: () => import(
            '@/views/atencao-basica/atividade-coletiva/Index'
        ),
        redirect: 'atividade-coletiva/index',
        children: [
            {
                name: 'atencao-basica-atividade-coletiva',
                path: 'index',
                props: true,
                component: () => import(
                    '@/views/atencao-basica/atividade-coletiva/List'
                ),
            },
            {
                name: 'atencao-basica-atividade-coletiva-create',
                path: 'create',
                component: () => import(
                    '@/views/atencao-basica/atividade-coletiva/Form'
                ),
            },
            {
                name: 'atencao-basica-atividade-coletiva-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    '@/views/atencao-basica/atividade-coletiva/Form'
                ),
            },
        ],
    },
]